var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(false)?_c('el-page-header',{attrs:{"title":"Geri","content":"Kontrol Planlama"},on:{"back":_vm.goBack}}):_vm._e(),_c('mak-kontrol-planlama')],1)}
var staticRenderFns = []

export { render, staticRenderFns }